export const Status = {
    "Enable": 1,
    "Disable": 0,
}